export default (snakeStr: string) =>
  snakeStr
    .toLowerCase()
    .replace(/(_\w)/g, (matches) => matches[1].toUpperCase());
